export default __webpack_public_path__ + "locales/tr/DeleteSelfProfileDialog.json?hash=fdf8c5c6c9e65b40cf5f723d71fe7de9";